var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 203.653,
    height: 126.646,
    viewBox: "0 0 203.653 126.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-502.075 -5675.787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.276,15.923s8.276,10.255,8.276,16.732a8.278,8.278,0,0,1-16.552,0C70,26.178,78.276,15.923,78.276,15.923Z",
    transform: "translate(451.385 5661.37)",
    fill: "#03532c",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.276,15.923s8.276,10.255,8.276,16.732a8.278,8.278,0,0,1-16.552,0C210,26.178,218.276,15.923,218.276,15.923Z",
    transform: "translate(350.007 5661.37)",
    fill: "#03532c",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.276,15.923s8.276,10.255,8.276,16.732a8.278,8.278,0,0,1-16.552,0C350,26.178,358.276,15.923,358.276,15.923Z",
    transform: "translate(248.628 5661.37)",
    fill: "#03532c",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.276,15.923s8.276,10.255,8.276,16.732a8.278,8.278,0,0,1-16.552,0C350,26.178,358.276,15.923,358.276,15.923Z",
    transform: "translate(287.249 5661.37)",
    fill: "#03532c",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.276,15.923s8.276,10.255,8.276,16.732a8.278,8.278,0,0,1-16.552,0C350,26.178,358.276,15.923,358.276,15.923Z",
    transform: "translate(325.87 5661.37)",
    fill: "#03532c",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.276,375.923s8.276,10.255,8.276,16.732a8.278,8.278,0,0,1-16.552,0C70,386.178,78.276,375.923,78.276,375.923Z",
    transform: "translate(451.385 5400.681)",
    fill: "#03532c",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.276,375.923s8.276,10.255,8.276,16.732a8.278,8.278,0,0,1-16.552,0C210,386.178,218.276,375.923,218.276,375.923Z",
    transform: "translate(350.007 5400.681)",
    fill: "#03532c",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.276,375.923a58.959,58.959,0,0,1,6.646,10.606,15.622,15.622,0,0,1,1.63,6.125,8.278,8.278,0,0,1-16.552,0C350,386.178,358.276,375.923,358.276,375.923Z",
    transform: "translate(248.628 5400.681)",
    fill: "#03532c",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.276,375.923a58.959,58.959,0,0,1,6.646,10.606,15.622,15.622,0,0,1,1.63,6.125,8.278,8.278,0,0,1-16.552,0C350,386.178,358.276,375.923,358.276,375.923Z",
    transform: "translate(287.249 5400.681)",
    fill: "#03532c",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.276,375.923a58.959,58.959,0,0,1,6.646,10.606,15.622,15.622,0,0,1,1.63,6.125,8.278,8.278,0,0,1-16.552,0C350,386.178,358.276,375.923,358.276,375.923Z",
    transform: "translate(325.87 5400.681)",
    fill: "#03532c",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 203.408,
    transform: "translate(502.319 5715.914)",
    fill: "none",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x2: 203.408,
    transform: "translate(502.075 5762.811)",
    fill: "none",
    stroke: "#03532c",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(511.21 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(511.21 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(527.762 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(527.762 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(544.314 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(544.314 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(560.866 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(560.866 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(577.417 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(577.417 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(593.969 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(643.625 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(593.969 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(643.625 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(610.521 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(660.177 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(627.073 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(676.729 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(693.281 5729.707)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(610.521 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(660.177 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(627.073 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(676.729 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.759,
    height: 2.759,
    transform: "translate(693.281 5746.259)",
    fill: "#8dc63e",
    stroke: "#8dc63f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon01.10df2fc5150d862971c1ebcdf1e49255.svg";
export { ForwardRef as ReactComponent };